// src/pages/Admin/StatistiquesComptabilite/utils/comptaDashboardUtils.js

export const TYPES_PAIEMENT_POSSIBLES = [
  "En ligne",
  "Chèque",
  "Espèces",
  "Virement",
  "CB",
  "Autre",
  "Non renseigné",
];

export function safeJsonParse(value, fallback = null) {
  try {
    return value ? JSON.parse(value) : fallback;
  } catch {
    return fallback;
  }
}

export function getStoredUserInfo() {
  return safeJsonParse(localStorage.getItem("userInfo"), null);
}

export function getUserRoleId(user) {
  return Number(
    user?.role_id ??
      user?.roleId ??
      user?.role?.id ??
      user?.Role?.id ??
      user?.user_role_id ??
      0
  );
}

export function unwrapSettings(settings) {
  if (!settings) return {};

  let output = settings;

  if (Array.isArray(output)) output = output[0] || {};
  if (output?.dataValues) output = output.dataValues;

  return output || {};
}

export function prevSeason(season) {
  const [start, end] = String(season || "")
    .split("-")
    .map(Number);

  if (!start || !end) return "";

  return `${start - 1}-${end - 1}`;
}

export function nextSeason(season) {
  const [start, end] = String(season || "")
    .split("-")
    .map(Number);

  if (!start || !end) return "";

  return `${start + 1}-${end + 1}`;
}

export function toAmount(value) {
  const number = Number.parseFloat(value || 0);
  return Number.isFinite(number) ? number : 0;
}

export function formatCurrency(value) {
  return Number(value || 0).toLocaleString("fr-FR", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function formatNumber(value) {
  return Number(value || 0).toLocaleString("fr-FR");
}

export function calculateComptaStats(reglements) {
  const list = Array.isArray(reglements) ? reglements : [];

  let licences = 0;
  let cotisationsBrutes = 0;
  let reductions = 0;
  let passSport = 0;

  const statutCounts = {};
  const typeCounts = {};

  for (const reglement of list) {
    const montantLicence = toAmount(reglement?.montant_lic_assurance);
    const montantCotisation = toAmount(reglement?.montant_cotisation);

    const reductionFoyer = Math.abs(toAmount(reglement?.reduction_foyer));
    const reductionSaison = Math.abs(toAmount(reglement?.reduction_saison));
    const montantPassSport = Math.abs(toAmount(reglement?.pass_sport));

    licences += montantLicence;
    cotisationsBrutes += montantCotisation;
    reductions += reductionFoyer + reductionSaison + montantPassSport;
    passSport += montantPassSport;

    const statut = String(
      reglement?.statut_reglement || "Non renseigné"
    ).trim();

    statutCounts[statut || "Non renseigné"] =
      (statutCounts[statut || "Non renseigné"] || 0) + 1;

    const type = String(reglement?.type_reglement || "Non renseigné").trim();

    typeCounts[type || "Non renseigné"] =
      (typeCounts[type || "Non renseigné"] || 0) + 1;
  }

  const cotisationsNettes = cotisationsBrutes - reductions;
  const totalReglements = licences + cotisationsNettes;
  const nombrePassSport = passSport ? Math.round(passSport / 50) : 0;

  const totalLignes = list.length || 1;

  const statutReglements = Object.entries(statutCounts)
    .map(([statut, count]) => ({
      statut,
      count,
      percent: Number(((count / totalLignes) * 100).toFixed(1)),
    }))
    .sort((a, b) => b.count - a.count);

  const typeReglements = TYPES_PAIEMENT_POSSIBLES.map((type) => {
    const count = typeCounts[type] || 0;

    return {
      type,
      count,
      percent: Number(((count / totalLignes) * 100).toFixed(1)),
    };
  }).filter((item) => item.count > 0 || item.type === "Non renseigné");

  return {
    licences,
    cotisationsBrutes,
    cotisationsNettes,
    reductions,
    totalReglements,
    passSport,
    nombrePassSport,
    nombreReglements: list.length,
    statutReglements,
    typeReglements,
  };
}

export function buildSeasonsFromActiveSeason(activeSeason) {
  return [
    prevSeason(activeSeason),
    activeSeason,
    nextSeason(activeSeason),
  ].filter(Boolean);
}

export function scrollToSection(sectionId) {
  if (!sectionId) return;

  const target = document.getElementById(sectionId);

  if (!target) return;

  target.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });
}

export function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}